module.exports = __webpack_public_path__ + "img/pdf.24e29351.jpeg";